module.exports = __webpack_public_path__ + "static/maracon_unicorn_pop-ba92d5f647a3da20dec757bb201b2dc7.jpg";